import React from 'react';

const MessagesPage = () => {
  return <div>MessagesPage</div>;
};

export default MessagesPage;
